const BATCH_NAME_PREFIX = 'expert-management-';

export const createBatchNameForTaskId = (taskId: string) => BATCH_NAME_PREFIX + taskId;

export const createBatchNameForProjectId = (projectId: string) => BATCH_NAME_PREFIX + projectId;

export const getTaskIdFromBatchName = (batchName: string): string | undefined =>
  isBatchNameValid(batchName) ? batchName.replace(BATCH_NAME_PREFIX, '') : undefined;

export const isBatchNameValid = (batchName: string) =>
  batchName.startsWith(BATCH_NAME_PREFIX) && batchName.split(BATCH_NAME_PREFIX)[1].length === 24;
